import React from 'react';

export default function PageFlipper({
  isFlipping,
  direction,
  flipProgress,
  phase,
  oldContent,
  newContent
}) {
  if (!isFlipping) return null;

  // Determine shadow phase class names based on progress/phases
  let shadowClass = 'shadow-phase-settle';
  let highlightClass = 'highlight-gone';
  let backShadowClass = 'back-shadow-gone';

  if (phase === 'lift') {
    shadowClass = 'shadow-phase-lift';
    highlightClass = 'highlight-visible';
  } else if (phase === 'curl') {
    // If progress is less than halfway (approx 40% of curl/total progress),
    // shadow falls on the right. After that, it flips to the left.
    if (flipProgress < 0.45) {
      shadowClass = 'shadow-phase-curl-start';
      highlightClass = 'highlight-narrowing';
    } else {
      shadowClass = 'shadow-phase-curl-end';
      highlightClass = 'highlight-gone';
      backShadowClass = 'back-shadow-visible';
    }
  } else if (phase === 'land') {
    shadowClass = 'shadow-phase-land';
    highlightClass = 'highlight-gone';
    backShadowClass = 'back-shadow-landing';
  } else if (phase === 'settle') {
    shadowClass = 'shadow-phase-settle';
    highlightClass = 'highlight-gone';
    backShadowClass = 'back-shadow-gone';
  }

  // Direction class
  const directionClass = direction === 'forward' ? 'direction-forward' : 'direction-backward';
  const phaseClass = `phase-${phase}`;

  return (
    <div
      className={`flip-page ${directionClass} ${phaseClass}`}
      style={{
        '--flip-progress': flipProgress,
        '--flip-direction': direction === 'forward' ? 1 : -1,
      }}
    >
      {/* ── Front Face (Old Content) ── */}
      <div className="flip-page__front">
        {oldContent}
        {/* Dynamic shadow on old page as it lifts */}
        <div className={`flip-page__shadow ${shadowClass}`} />
        <div className={`flip-page__curl-highlight ${highlightClass}`} />
      </div>

      {/* ── Back Face (New Content) ── */}
      <div className="flip-page__back">
        {newContent}
        {/* Shadow on back face as it lands */}
        <div className={`flip-page__back-shadow ${backShadowClass}`} />
      </div>
    </div>
  );
}
